import { useState, useEffect, useCallback, useRef } from 'react';
import { AxiosResponse } from 'axios';
import axios from 'axios';

export function useInifiniteScroll({apiFunction,limit=10}:{apiFunction: (limit: number,cursor?: string |null) => Promise<AxiosResponse<any>> , limit?:number})
{
    const [data,setData] = useState<any[]>([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)
    const [hasMore, setHasMore] = useState(true)
    const [cursor, setCursor] = useState<string | null>(null)

    const isLoadingRef = useRef(false)

      const limitRef = useRef(limit);

    const loadMoreData = useCallback(async ()=>{
        
        if (isLoadingRef.current || !hasMore) return
            
        isLoadingRef.current = true
        setLoading(true)
        setError(null)

        try
        {

            const response = await apiFunction(limitRef.current,cursor)

            if(response.data.success)
            {
            
                setData(prev => [...prev, ...response.data.data])
                setCursor(response.data.pagination.cursor)
                setHasMore(response.data.pagination.hasMore)
            }
        }
        catch
        {
             if (axios.isAxiosError(error)) {
                if (error.response?.status === 429) 
                {
                    setError('Demasiadas peticiones. Por favor espera un momento.')
                } 
                else 
                {
                    setError('Error al cargar datos. Intenta de nuevo.')
                }
            } else {
                setError('Error inesperado al cargar datos.')
            }
            console.error('Error cargando usuarios:', error)
        }
        finally
        {
            setLoading(false)
            isLoadingRef.current = false
        }

    }, [cursor,hasMore,apiFunction])

    useEffect(()=>{
        loadMoreData()
    },[])

    return {data,loading,error,hasMore,loadMore:loadMoreData}

}